import { render, staticRenderFns } from "./BulkDeleteEligibleTable.vue?vue&type=template&id=06e0212b&scoped=true"
import script from "./BulkDeleteEligibleTable.vue?vue&type=script&lang=js"
export * from "./BulkDeleteEligibleTable.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteEligibleTable.vue?vue&type=style&index=0&id=06e0212b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0212b",
  null
  
)

export default component.exports